import axios from 'axios'

export default {
    getPayMethodList({commit}, params){
        return axios.post('/api/background/pay_settings/list', params)
    },
    addPayMethod({commit}, params){
        return axios.post('/api/background/pay_settings/add', params)
    },
    moidfyPayMethod({commit}, params){
        return axios.post('/api/background/pay_settings/modify', params)
    },
    deletePayMethod({commit}, params){
        return axios.post('/api/background/pay_settings/delete', params)
    },
    getCompanyPayWayList({commit}, params){
        return axios.post('/api/background/pay_settings/company_payinfo/list', params)
    },
    getPayTypeList({commit}, params){
        return axios.post('/api/background/pay_settings/all_payinfo/list', params)
    },
    getCompanyPayInfoStatusList({commit}, params){
        return axios.post('/api/background/pay_settings/company_payinfo/stauts/list', params)
    },
     // 美团
    addMeituanInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/meituan_info/add', params)
    },
    modifyMeituanInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/meituan_info/modify', params)
    },
    deleteMeituanInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/meituan_info/delete', params)
    },

    // 收钱吧
    addShouqianbaInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/shouqianba_info/add', params)
    },
    modifyShouqianbaInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/shouqianba_info/modify', params)
    },
    deleteShouqianbaInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/shouqianba_info/delete', params)
    },

    // 趣钱包
    addQuqianbaoInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/quqianbao_info/add', params)
    },
    modifyQuqianbaoInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/quqianbao_info/modify', params)
    },
    deleteQuqianbaoInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/quqianbao_info/delete', params)
    },

    // 建行支付
    addCBBInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/cbb_info/add', params)
    },
    modifyCBBInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/cbb_info/modify', params)
    },
    deleteCBBInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/cbb_info/delete', params)
    },

    // 通联支付
    addAllinInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/allinpay_info/add', params)
    },
    modifyAllinInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/allinpay_info/modify', params)
    },
    deleteAllinInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/allinpay_info/delete', params)
    },

    // 大学城支付
    addDXCInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/daxuecheng_info/add', params)
    },
    modifyDXCInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/daxuecheng_info/modify', params)
    },
    deleteDXCInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/daxuecheng_info/delete', params)
    },

    // 银联支付
    addUnionInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/unionpay_info/add', params)
    },
    modifyUnionInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/unionpay_info/modify', params)
    },
    deleteUnionInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/unionpay_info/delete', params)
    },

    // 预充值
    addPrechargeInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/precharge_info/add', params)
    },
    modifyPrechargeInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/precharge_info/modify', params)
    },
    deletePrechargeInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/precharge_info/delete', params)
    },

    // 星微门
    addXinwenmenInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/xingweimen_info/add', params)
    },
    modifyXinwenmenInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/xingweimen_info/modify', params)
    },
    deleteXinwenmenInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/xingweimen_info/delete', params)
    },

    // 易付宝
    addYifubaoInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/yifubao_info/add', params)
    },
    modifyYifubaoInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/yifubao_info/modify', params)
    },
    deleteYifubaoInfo({ commit }, params) {
        return axios.post('/api/background/pay_settings/yifubao_info/delete', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/pay.js